import {
    SET_COMPANY_DATA,
    SET_RETURN_FROM_ARTICLE_PAGE_FLAG
} from './CreateNewEntity.actions';

function thirdPartyPages(state = null, action) {

    switch(action.type) {

        case SET_COMPANY_DATA:
            return Object.assign(
                {}, state, {
                    companyData: action.payload
                }
            );

        case SET_RETURN_FROM_ARTICLE_PAGE_FLAG:
            return Object.assign(
                {}, state, {
                    isReturningFromArticlePage: action.payload
                }
            );

        default:
            return state;

    }

}

export default thirdPartyPages;


// WEBPACK FOOTER //
// ./src/scripts/pages/CreateNewEntity/CreateNewEntity.reducers.js